var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.59998C12.3182 3.59998 12.6235 3.7264 12.8485 3.95145C13.0735 4.17649 13.2 4.48172 13.2 4.79998V10.8H19.2C19.5182 10.8 19.8235 10.9264 20.0485 11.1514C20.2735 11.3765 20.4 11.6817 20.4 12C20.4 12.3182 20.2735 12.6235 20.0485 12.8485C19.8235 13.0735 19.5182 13.2 19.2 13.2H13.2V19.2C13.2 19.5182 13.0735 19.8235 12.8485 20.0485C12.6235 20.2735 12.3182 20.4 12 20.4C11.6817 20.4 11.3765 20.2735 11.1514 20.0485C10.9264 19.8235 10.8 19.5182 10.8 19.2V13.2H4.79998C4.48172 13.2 4.17649 13.0735 3.95145 12.8485C3.7264 12.6235 3.59998 12.3182 3.59998 12C3.59998 11.6817 3.7264 11.3765 3.95145 11.1514C4.17649 10.9264 4.48172 10.8 4.79998 10.8H10.8V4.79998C10.8 4.48172 10.9264 4.17649 11.1514 3.95145C11.3765 3.7264 11.6817 3.59998 12 3.59998Z",
    fill: "#4A3DFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiPlus);
export default __webpack_public_path__ + "static/media/HiPlus.88ecca707136b7bad5866fe2b5b25e13.svg";
export { ForwardRef as ReactComponent };